"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const locale = {
  setColumnButtonTip: 'Column config',
  setColumnDropdown_title: 'Columns',
  setColumnDropdown_confirm: 'Confirm',
  exportButtonTip: 'Export to CSV',
  exportModal_current: 'Export Current Page Content',
  exportModal_all: 'Export All Search Results',
  exportModal_fields: 'Select the columns',
  exportModal_clear: 'Clear selected',
  exportModal_selectAll: 'Select All',
  exportModal_download: 'Download',
  exportModal_title: 'Export to CSV',
  antdTableLocale: {
    emptyText: 'No Data'
  },
  filter_selectAllText: 'All',
  selectionModal_total: '{selectedTotal} {selectedTotal:Result/Results} selected',
  resetColumnWidth: 'Reset',
  resetColumnWidthTooltip: 'Reset column width'
};
var _default = exports.default = locale;